import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './app.scss';
// import 'es6-shim';

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { BootstrapVue, BootstrapVueIcons , ToastPlugin } from 'bootstrap-vue';


import Controls from '@servicestack/vue';
import BaseBlock from '../src/components/BaseBlock.vue';
import BaseBackground from '../src/components/BaseBackground.vue';
import BaseNavigation from '../src/components/BaseNavigation.vue';
import Vidle from 'v-idle';
import VueSweetalert2 from 'vue-sweetalert2';

const options = {
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn btn-success m-1',
    cancelButton: 'btn btn-danger m-1',
    input: 'form-control',
  },
};

// Register Vue SweetAlert2 with custom options
Vue.use(VueSweetalert2, options);
Vue.use(Controls);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(ToastPlugin);

Vue.use(Vuelidate);
Vue.use(Vidle);

// Register global components
Vue.component('BaseBlock', BaseBlock);
Vue.component('BaseBackground', BaseBackground);
Vue.component('BaseNavigation', BaseNavigation);

import App from './App.vue';

import { router } from './shared/router';

const app = new Vue({
  el: '#app',
  render: (h: any) => h(App),
  router,
});
